import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RefreshProps {
  color?: string;
  style?: React.CSSProperties;
}

export const PlusIcon = ({ color = RoutalPalette.primary40, style = {}, ...props }: RefreshProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15" style={{ width: `15px`, height: `15px`, ...style }}>
      <g clipPath="url(#clip0_708_21412)">
        <path d="M7.45508 1.45752V13.0377" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.66504 7.24756H13.2452" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  );
};
